module.exports = __webpack_public_path__ + "static/about-4-fe47d11b739059ce6c3ffa617e6036a5.jpg";